import { AutogenLayoutPendingPayAdjustReport} from "./autogen/AutogenLayoutPendingPayAdjustReport";


export class PendingPayAdjustReport extends AutogenLayoutPendingPayAdjustReport {
    override onLoad(): void {
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
    }
    
    textboxGroupByOnChange() {
        const reportType = this.textboxGroupBy.text
        if (reportType == "Payee") {
            this.checkboxSubtotalByTractor.enabled = true;
        } else {
            this.checkboxSubtotalByTractor.enabled = false;
            this.checkboxSubtotalByTractor.checked = false;
        }
    }
}